import styled, { css } from 'styled-components';
import { FormSelectContainerProps, SelectContainerProps, SelectLabelProps, IconWrapperProps, ErrorMessageProps } from './types';


export const FormSelectContainer = styled.div<FormSelectContainerProps>`
  display: flex;
  ${({ labelPosition }) =>
    labelPosition === 'left'
      ? css`
          flex-direction: row;
          align-items: center;
        `
      : css`
          flex-direction: column;
        `}
  position: relative;
  width: ${({ fullWidth, width }) => (fullWidth ? '100%' : width || 'auto')};
  margin-bottom: ${({ labelPosition }) => (labelPosition === 'left' ? '16px' : '20px')};
`;

export const SelectLabel = styled.label<SelectLabelProps>`
  font-size: 15px;
  color: ${({ theme, hasError }) =>
    hasError ? theme.secondaryColor : theme.textColor};
  margin-bottom: ${({ labelPosition }) =>
    labelPosition === 'top' ? '6px' : '0'};
  margin-right: ${({ labelPosition }) =>
    labelPosition === 'left' ? '10px' : '0'};
  font-weight: 700;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: ${({ labelPosition }) =>
    labelPosition === 'left' ? '130px' : 'auto'};
  text-align: ${({ labelPosition }) =>
    labelPosition === 'left' ? 'right' : 'left'};

  ${({ required }) =>
    required &&
    css`
      &::after {
        content: '*';
        color: ${({ theme }) => theme.secondaryColor};
        margin-left: 4px;
      }
    `}
`;

export const SelectContainer = styled.div<SelectContainerProps>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  ${({ inputSize }) => {
    switch (inputSize) {
      case 'small':
        return css`
          height: 32px;
        `;
      case 'large':
        return css`
          height: 48px;
        `;
      case 'medium':
      default:
        return css`
          height: 40px;
        `;
    }
  }}
`;

export const Select = styled.select<SelectContainerProps>`
  flex: 1;
  height: 100%;
  padding: ${({ hasLeftIcon, inputSize }) => {
    const paddingLeft = hasLeftIcon ? '36px' : '12px';

    const verticalPadding = inputSize === 'small'
      ? '4px'
      : inputSize === 'large'
        ? '12px'
        : '8px';

    return `${verticalPadding} 32px ${verticalPadding} ${paddingLeft}`;
  }};

  appearance: none;
  border: 1px solid ${({ theme, hasError, isFocused }) =>
    hasError
      ? theme.secondaryColor
      : isFocused
        ? theme.primaryColor
        : theme.borderColor};
  border-radius: 4px;
  font-size: ${({ inputSize }) =>
    inputSize === 'small'
      ? '14px'
      : inputSize === 'large'
        ? '16px'
        : '14px'};
  background-color: ${({ theme, disabled }) => disabled ? theme.lightGrayColor : theme.white};
  color: ${({ theme, disabled }) => disabled ? theme.darkGray : theme.textColor};
  transition: all 0.2s ease;
  outline: none;
  width: 100%;
  cursor: pointer;

  &:focus {
    border-color: ${({ theme, hasError }) => hasError ? theme.secondaryColor : theme.primaryColor};
    box-shadow: 0 0 0 2px ${({ theme, hasError }) =>
      hasError
        ? `${theme.secondaryColor}33`
        : `${theme.primaryColor}33`};
  }

  ${({ hasError, theme }) =>
    hasError &&
    css`
      border-color: ${theme.secondaryColor};
      &:focus {
        border-color: ${theme.secondaryColor};
      }
    `}

  /* Adiciona validação de required quando vazio */
  &:invalid:required:not(:focus) {
    border-color: ${({ theme }) => theme.secondaryColor};
  }
`;

export const ChevronIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.darkGray};
  pointer-events: none;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorMessage = styled.span<ErrorMessageProps>`
  font-size: 12px;
  color: ${({ theme }) => theme.secondaryColor};
  margin-top: 4px;
  display: block;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  height: 16px; /* Altura fixa para manter o espaço mesmo quando vazio */
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

export const HelperText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.darkGray};
  margin-top: 4px;
  display: block;
`;

export const IconWrapper = styled.div<IconWrapperProps>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ position }) => position === 'left' ? 'left: 12px;' : 'right: 12px;'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.darkGray};
  font-size: 16px;
  pointer-events: none;
`;
